import { render, staticRenderFns } from "./lineweight.vue?vue&type=template&id=40b72ba4&scoped=true"
import script from "./lineweight.vue?vue&type=script&lang=js"
export * from "./lineweight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b72ba4",
  null
  
)

export default component.exports